<template>
  <font-awesome-icon v-if="fa" :icon="icon" :color="hexColor" :size="faSize" />

  <q-icon
    v-else
    :name="!loading ? icon : undefined"
    :size="iconSize"
    :color="color"
    :left="isPositionLeft"
    :right="isPositionRight"
    :class="[customClass, { 'cursor-pointer': isIconClickable }]"
  >
    <q-spinner-oval v-if="loading" :color="color" :size="size" />
  </q-icon>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { EnumIconPosition } from 'src/models/components/enums/Positions'
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/vue-fontawesome'
type FontAwesomeSize = FontAwesomeIconProps['size']

import { colors } from 'quasar'
const { getPaletteColor } = colors

const attrs = useAttrs()

const defaultIconSize = 16
const props = withDefaults(
  defineProps<{
    customClass?: string
    icon: string
    loading?: boolean
    color?: string
    size?: number | FontAwesomeSize
    position?: EnumIconPosition
    fa?: boolean
  }>(),
  {
    icon: 'question_mark',
    size: defaultIconSize,
  },
)
const faSize = computed(() => {
  return props.size as FontAwesomeSize
})

const iconSize = computed(() => `${props.size}px`)
const isPositionRight = computed(
  () => props.position === EnumIconPosition.Right,
)
const isPositionLeft = computed(() => props.position === EnumIconPosition.Left)
const isIconClickable = computed(() => !!attrs.onClick)

const hexColor = computed(() => {
  if (!props.color) return
  return getPaletteColor(props.color)
})
</script>
